import React from 'react';
import NumberFormat from 'react-number-format';
import TextInput from './TextInput';

const CurrencyInput = props => {
  const {
    thousandSeparator = 'true',
    prefix = '$',
    type = '',
    mask = ' ',
    InputProps = {},
    ...rest
  } = props;

  return (
    <NumberFormat
      thousandSeparator={thousandSeparator}
      prefix={prefix}
      type={type}
      mask={mask}
      customInput={TextInput}
      InputProps={InputProps}
      {...rest}
    />
  );
};

export default CurrencyInput;
